import locale from "../translations_i18n";
import VueI18n from "vue-i18n";
import Vue from "vue";
Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: "es", // set translations_i18n
  messages: locale // set translations_i18n messages
});

export default i18n;
